import KadChartist from 'libs/kad-chartist';
export default {
  init: function() {
    //Chartist examples
    var chartData = {
      labels: ['One', 'Two', 'Three', 'Four', 'Five'],
      series: [
        { name: 'My Data', data: _.range(1, 6) }
      ]
    };

    var donutOptions = {
      type: 'donut',
      data: {
        series: _(5).times(function(n) { return { name: 'Data Label', value: n + 1 }; })
      }
    };

    new KadChartist.Chart('.js-chart-donut-1', donutOptions);
    new KadChartist.Chart('.js-chart-bar-1', { data: chartData });
    new KadChartist.Chart('.js-chart-line-1', { data: chartData, type: 'line' });
    new KadChartist.Chart('.js-chart-donut-2', donutOptions);
    new KadChartist.Chart('.js-chart-bar-2', { data: chartData });

    // Basic KO example

    var chartViewModel = function(selector, chartType) {
      var self = this;

      self.chartLastPage = ko.observable(false);
      self.chartFirstPage = ko.observable(true);

      self.chartSelector = selector;
      self.chartType = chartType;

      self.data = {
        labels: ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve'],
        series: [
          { name: 'My Data', data: _.range(1, 13) },
          { name: 'My Data 2', data: _.range(2, 14)}
        ]
      };

      self.init = function() {
        self.chart = new KadChartist.Chart(self.chartSelector, { data: self.data, paginatePer: 4, type: self.chartType });
      };

      self.chartNext = function() {
        self.chart.nextPage();
        self.checkChartPage();
      };

      self.chartPrev = function() {
        self.chart.prevPage();
        self.checkChartPage();
      };

      self.checkChartPage = function() {
        self.chartLastPage(self.chart.isLastPage);
        self.chartFirstPage(self.chart.isFirstPage);
      };

      self.init();
    };

    ko.applyBindings(new chartViewModel('.js-chart-line-2', 'line'), document.querySelector('.chart-pagination-example-2'));
    ko.applyBindings(new chartViewModel('.js-chart-bar-3', 'bar'), document.querySelector('.chart-pagination-example-1'));

    //Chart JS examples

    var doughnutChartElement = document.getElementById('chartjs-doughnut');
    var doughnutChart = new Chart(doughnutChartElement, {
      type: 'doughnut',
      animation: {
        animateScale: true
      },
      options: {
        cutoutPercentage: 90,
        rotation: 2 * Math.PI,
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
      },
      data: {
        labels: ['Free', 'Premium', 'For Credit'],
        datasets: [{
          data: [300, 50, 100],
          backgroundColor: ['#a3c7c9','#889d9e','#647678'],
          borderWidth: 2,
          hoverBackgroundColor: ['#96b7b9','#718283','#5c6b6d']
        }]
      }
    });

    var lineChartElement = document.getElementById('chartjs-line');
    var lineChart = new Chart(lineChartElement, {
      type: 'line',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'My First dataset',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [65, 59, 80, 81, 56, 55, 40],
            spanGaps: false,
          }
        ]
      }
    });
  }
};

